// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__jWoEk","menuOpened":"styles_menuOpened__XfDBU","menuItemsContainer":"styles_menuItemsContainer__rRHUH"};